import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import './Tooltip.scss';

const Tooltip = () => (
  <ReactTooltip
    type="light"
    className="tooltip"
    effect="solid"
    border={true}
  />
)

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.tsx